import React from "react";
import { Col, Container, Row } from "reactstrap";
import './Service.css'
import { IconCamera, IconFlask, IconSearch } from "@tabler/icons-react";

const Services = () => {
  return (
    <React.Fragment>
      <section className="section" id="services">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <div className="heading-box text-center">
                <h1 className="display-5 fw-bold">Our Services</h1>
              </div>
            </Col>
          </Row>

          <Row className="pt-4">
            <Col lg={4}>
              <div className="services-box text-center hover-effect mt-4">
                <div className="services-icon">
                  <IconSearch className="mt-4" style={{ color: 'white' }} size={30} />
                </div>
                <h5 className="mt-4 pt-1 text-start ms-3">
                  Machine Vision Consultancy
                </h5>

                <ul className="services-list text-muted text-start mt-3">
                  <li>Surface Defect Inspection</li>
                  <li>Dimensional Measurement (Sub-pixel accuracy)</li>
                  <li>Presence / Absence checks</li>
                  <li>Barcode, OCR & OCV</li>
                  <li>Color Inspection and Analysis</li>
                  <li>AI Based Machine Vision Software</li>
                  <li>Machine Vision Configuration Tool</li>
                </ul>
              </div>
            </Col>

            <Col lg={4}>
              <div className="services-box text-center hover-effect mt-4">
                <div className="services-icon">
                  <IconFlask className="mt-3" style={{ color: 'white' }} size={35} />
                </div>
                <div className="ms-5">
                  <h5 className="mt-4 pt-1 text-start">LabVIEW Consultancy</h5>

                  <ul className="services-list text-muted text-start mt-3">
                    <li>DAQ and Sensor integration</li>
                    <li>Instrument Control (USB, RS-232, Ethernet)</li>
                    <li>Automated Test Systems</li>
                    <li>Data logging & Reports</li>
                    <li>HMI and Dashboards</li>
                  </ul>
                </div>
              </div>
            </Col>

            <Col lg={4}>
              <div className="services-box text-center hover-effect mt-4">
                <div className="services-icon">
                  <IconCamera className="mt-3" style={{ color: 'white' }} size={35} />
                </div>
                <h5 className="mt-4 pt-1 text-start ms-3">
                  Customised Smart Camera Solutions
                </h5>

                <ul className="services-list text-muted text-start mt-3">
                  <li>High-speed Web Inspection</li>
                  <li>PLC and Robot Integration</li>
                  <li>Stand-alone Vision Systems</li>
                  <li>Embedded Vision</li>
                  <li>Edge AI Inspection</li>
                  <li>FPGA and GPU Programming</li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Services;
